import React from "react";
import {
    Box,
    Button,
    Chip,
    Skeleton,
    IconButton,
    Typography,
    Table,
    TableRow,
    TableHead,
    TableBody,
    TableCell,
} from "@mui/material";
import {
    Edit as EditIcon,
    Delete as DeleteIcon,
} from "@mui/icons-material";
import {useCardStyles} from "../../constants/styles";
import {schemeLabels, schemeColors} from "../../constants/schemes";

const SectionsTable = (props) => {
    const {
        sections,
        isLoading,
        expandedSectionId,
        onExpandSection,
        onCreateSection,
        onEditSection,
        onDeleteSection,
    } = props;
    const classes = useCardStyles();

    return (
        <Box className={classes.root}>
            <Box display="flex" justifyContent="space-between" alignItems="center" mb={2}>
                <Typography variant="h3" textAlign="left">Разделы справочника</Typography>
                <Button
                    size="small"
                    variant="contained"
                    onClick={onCreateSection}
                >Добавить раздел</Button>
            </Box>

            <Table size="small">
                <TableHead>
                    <TableRow>
                        <TableCell>Название</TableCell>
                        <TableCell>Позиции в VIN</TableCell>
                        <TableCell>Схема</TableCell>
                        <TableCell align="right">Действия</TableCell>
                    </TableRow>
                </TableHead>
                <TableBody>
                    <VisibleContent visible={!isLoading}>
                        {(sections || []).map((section) => (
                            <TableRow
                                key={`section-${section.id}`}
                                hover
                                selected={expandedSectionId === section.id}
                                sx={{cursor: "pointer"}}
                                onClick={() => onExpandSection(section.id)}
                            >
                                <TableCell sx={{fontWeight: expandedSectionId === section.id ? "bold" : "normal"}}>
                                    {section.title}
                                </TableCell>
                                <TableCell>{section.position_from} — {section.position_to}</TableCell>
                                <TableCell>
                                    <Chip
                                        label={schemeLabels[section.scheme] || section.scheme}
                                        size="small"
                                        color={schemeColors[section.scheme] || "default"}
                                    />
                                </TableCell>
                                <TableCell align="right" onClick={(e) => e.stopPropagation()}>
                                    <IconButton size="small" onClick={() => onEditSection(section)}>
                                        <EditIcon fontSize="small"/>
                                    </IconButton>
                                    <IconButton size="small" color="error" onClick={() => onDeleteSection(section)}>
                                        <DeleteIcon fontSize="small"/>
                                    </IconButton>
                                </TableCell>
                            </TableRow>
                        ))}
                        <VisibleContent visible={(sections || []).length === 0}>
                            <TableRow>
                                <TableCell colSpan={4} align="center">
                                    <Typography color="textSecondary" py={2}>Разделы не найдены</Typography>
                                </TableCell>
                            </TableRow>
                        </VisibleContent>
                    </VisibleContent>
                    <VisibleContent visible={isLoading}>
                        <LoadingRows/>
                    </VisibleContent>
                </TableBody>
            </Table>
        </Box>
    );
};

const LoadingRows = () => {
    return new Array(5).fill(1).map((_, i) => (
        <TableRow key={`loading-${i}`}>
            <TableCell><Skeleton/></TableCell>
            <TableCell><Skeleton/></TableCell>
            <TableCell><Skeleton/></TableCell>
            <TableCell><Skeleton/></TableCell>
        </TableRow>
    ));
};

const VisibleContent = ({visible, children}) => {
    if (!visible) return null;
    return children;
};

export default SectionsTable;
